// data/quoteData.js

// Customer Suggestions
export const customerSuggestions = [
  'ABC Corp',
  'XYZ Ltd',
  'Global Logistics',
  'Express Traders',
  'International Shipping Co',
  'Prime Freight Services',
  'Elite Trading Group',
  'Pacific Importers',
  'Atlantic Exports Inc',
  'Continental Logistics'
];

// Location Suggestions
export const locationSuggestions = {
  pickup: [
    'Colombo Port',
    'BIA Cargo Terminal',
    'Hambantota Port',
    'Chennai Port',
    'Mumbai Port',
    'Singapore Port',
    'Dubai Cargo Village',
    'Warehouse - Katunayake',
    'Warehouse - Colombo',
    'Customer Premises'
  ],
  delivery: [
    'Colombo',
    'Galle',
    'Kandy',
    'Jaffna',
    'Trincomalee',
    'Negombo',
    'Kurunegala',
    'Anuradhapura',
    'Batticaloa',
    'Matara'
  ]
};

// Airport Suggestions (IATA Codes)
export const airportSuggestions = [
  'Aarhus(AAR)',
  'Abadan(ABD)',
  'Abeché(AEH)',
  'Aberdeen(ABZ)',
  'Aberdeen (SD)(ABR)',
  'Abidjan(ABJ)',
  'Abilene (TX)(ABI)',
  'Abu Dhabi - Abu Dhabi International(AUH)',
  'Abu Rudeis(AUE)',
  'Abu Simbel(ABS)',
  'Abuja - Nnamdi Azikiwe International Airport(ABV)',
  'Acapulco(ACA)',
  'Accra - Kotoka International Airport(ACC)',
  'Adana(ADA)',
  'Addis Ababa - Bole International Airport(ADD)',
  'Adelaide(ADL)',
  'Aden - Aden International Airport(ADE)',
  'Adiyaman(ADF)',
  'Adler/Sochi(AER)',
  'Agades(AJY)',
  'Agadir(AGA)',
  'Agana (Hagåtña)(SUM)',
  'Aggeneys(AGZ)',
  'Aguadilla(BQN)',
  'Aguascaliente(AGU)',
  'Ahmedabad(AMD)',
  'Aiyura(AYU)',
  'Ajaccio(AJA)',
  'Akita(AXT)',
  'Akron (OH)(CAK)',
  'Akrotiri - RAF(AKT)',
  'Al Ain(AAN)',
  'Al Arish(AAC)',
  'Al Hoceima(AHU)',
  'Albany(ALH)',
  'Albany (GA)(ABY)',
  'Albany (NY) - Albany International Airport(ALB)',
  'Albi(LBI)',
  'Alborg(AAL)',
  'Albuquerque (NM)(ABQ)',
  'Albury(ABX)',
  'Alderney(ACI)',
  'Aleppo(ALP)',
  'Alesund(AES)',
  'Alexander Bay - Kortdoorn(ALJ)',
  'Alexandria - Esler Field(ESF)',
  'Alexandria - Borg el Arab Airport(HBH)',
  'Alexandria - El Nhouza Airport(ALY)',
  'Alghero Sassari(AHO)',
  'Algiers, Houari Boumediene Airport(ALG)',
  'Alicante(ALC)',
  'Alice Springs(ASP)',
  'Alldays(ADY)',
  'Allentown (PA)(ABE)',
  'Almaty (Alma Ata) - Almaty International Airport(ALA)',
  'Almeria(LEI)',
  'Alta(ALF)',
  'Altay(AAT)',
  'Altenrhein(ACH)',
  'Altoona (PA)(AOO)',
  'Altus(AXS)',
  'Amami(ASJ)',
  'Amarillo (TX)(AMA)',
  'Amazon Bay(AZB)',
  'Amman - Amman-Marká International Airport(ADJ)',
  'Amman - Queen Alia International Airport(AMM)',
  'Amritsar(ATQ)',
  'Amsterdam - Amsterdam Airport Schiphol(AMS)',
  'Anand(QNB)',
  'Anchorage (AK) - Ted Stevens Anchorage International(ANC)',
  'Ancona - Ancona Falconara Airport(AOI)',
  'Andorra La Vella - Heliport(ALV)',
  'Anguilla(AXA)',
  'Anjouan - Anjouan Airport(AJN)',
  'Ankara(ANK)',
  'Ankara - Esenboğa International Airport(ESB)',
  'Ann Arbor (MI)(ARB)',
  'Annaba(AAE)',
  'Annecy(NCY)',
  'Anniston (AL)(ANB)',
  'Antalya(AYT)',
  'Antananarivo (Tananarive) - Ivato International Airport(TNR)',
  'Antigua, V.C. Bird International(ANU)',
  'Antwerp(ANR)',
  'Aomori(AOJ)',
  'Apia - Faleolo International Airport(APW)',
  'Appleton/Neenah/Menasha (WI)(ATW)',
  'Aqaba(AQJ)',
  'Aracaju(AJU)',
  'Araxos(GPA)',
  'Arkhangelsk(ARH)',
  'Arlit(RLT)',
  'Arrecife/Lanzarote(ACE)',
  'Aruba - Reina Beatrix International, Oranjestad(AUA)',
  'Arusha(ARK)',
  'Asheville (NC)(AVL)',
  'Ashgabat - Saparmurat Turkmenbashy Int. Airport(ASB)',
  'Asmara - Asmara International(ASM)',
  'Aspen (CO) - Aspen-Pitkin County Airport(ASE)',
  'Assiut(ATZ)',
  'Astana - Astana International Airport(TSE)',
  'Asuncion - Asunción International Airport(ASU)',
  'Aswan - Daraw Airport(ASW)',
  'Athens (GA)(AHN)',
  'Athens (OH)(ATO)',
  'Athens - Elefthérios Venizélos International Airport(ATH)',
  'Athens, Hellinikon Airport(HEW)',
  'Atlanta (GA) - Hartsfield Atlanta International Airport(ATL)',
  'Atlantic City (NJ) - Atlantic City International(ACY)',
  'Attawapiskat(YAT)',
  'Auckland - Auckland International Airport(AKL)',
  'Augsburg - Augsburg Airport(AGB)',
  'Augusta (GA)(AGS)',
  'Augusta (ME) - Augusta State Airport(AUG)',
  'Aurillac(AUR)',
  'Austin (TX) - Austin-Bergstrom Airport(AUS)',
  'Ayawasi(AYW)',
  'Ayers Rock - Connellan(AYQ)',
  'Ayr(AYR)',
  'Badajoz(BUZ)',
  'Bagdad - Baghdad International Airport(BGW)',
  'Bagdogra(IXB)',
  'Bahamas - Lynden Pindling International Airport(NAS)',
  'Bahawalpur(BHV)',
  'Bahrain - Bahrain International Airport(BAH)',
  'Bakersfield (CA)(BFL)',
  'Baku - Heydar Aliyev International Airport(BAK)',
  'Ballina(BNK)',
  'Baltimore (MD) - Washington International Airport(BWI)',
  'Bamaga(ABM)',
  'Bamako - Bamako-Sénou International Airport(BKO)',
  'Bambari(BBY)',
  'Bandar Seri Begawan - Brunei International Airport(BWN)',
  'Bandung - Husein Sastranegara International Airport(BDO)',
  'Bangalore(BLR)',
  'Bangassou(BGU)',
  'Bangkok, Don Muang(DMK)',
  'Bangkok, Suvarnabhumi International(BKK)',
  'Bangor (ME)(BGR)',
  'Bangui - M\'Poko International Airport(BGF)',
  'Banjul - Banjul International Airport(BJL)',
  'Bannu(BNP)',
  'Barcelona(BCN)',
  'Barcelona(BLA)',
  'Bardufoss(BDU)',
  'Bari(BRI)',
  'Barisal(BZL)',
  'Baroda(BDQ)',
  'Barra (the famous tidal beach landing)(BRR)',
  'Barranquilla(BAQ)',
  'Basel(BSL)',
  'Basel/Mulhouse(EAP)',
  'Basra, Basrah(BSR)',
  'Basse-Terre - Pointe-à-Pitre International Airport(PTP)',
  'Basseterre - Robert L. Bradshaw International Airport(SKB)',
  'Bastia(BIA)',
  'Baton Rouge (LA) - Baton Rouge Metropolitan Airport(BTR)',
  'Bayreuth - Bindlacher-Berg(BYU)',
  'Beaumont/Pt. Arthur (TX)(BPT)',
  'Beckley (WV)(BKW)',
  'Beef Island - Terrance B. Lettsome(EIS)',
  'Beijing(PEK)',
  'Beijing - Nanyuan Airport(NAY)',
  'Beira(BEW)',
  'Beirut - Beirut Rafic Hariri International Airport(BEY)',
  'Belem - Val de Cans International Airport(BEL)',
  'Belfast - Belfast International Airport(BFS)',
  'Belfast - George Best Belfast City Airport(BHD)',
  'Belgaum(IXG)',
  'Belgrad (Beograd) - Belgrade Nikola Tesla International(BEG)',
  'Belize City - Philip S.W.Goldson International(BZE)',
  'Bellingham (WA)(BLI)',
  'Belo Horizonte - Tancredo Neves International Airport(CNF)',
  'Bemidji (MN)(BJI)',
  'Benbecula(BEB)',
  'Benghazi (Bengasi)(BEN)',
  'Benguela(BUG)',
  'Benton Harbour (MI)(BEH)',
  'Berberati(BBT)',
  'Bergamo/Milan - Orio Al Serio(BGY)',
  'Bergen(BGO)',
  'Bergerac - Roumanieres(EGC)',
  'Berlin(BER)',
  'Berlin, Schoenefeld(SXF)',
  'Berlin, Tegel(TXL)',
  'Berlin, Tempelhof(THF)',
  'Bermuda - L.F. Wade International Airport(BDA)',
  'Berne, Bern-Belp(BRN)',
  'Berne, Railway Service(ZDJ)',
  'Bethel (AK)(BET)',
  'Bhopal(BHO)',
  'Bhubaneswar(BBI)',
  'Biarritz(BIQ)',
  'Bilbao(BIO)',
  'Billings (MT)(BIL)',
  'Billund(BLL)',
  'Bintulu(BTU)',
  'Biraro(IRO)',
  'Birmingham (AL)(BHM)',
  'Birmingham - Birmingham International Airport(BHX)',
  'Bishkek - Manas International Airport(FRU)',
  'Bismarck (ND) - Bismarck Municipal Airport(BIS)',
  'Bissau - Osvaldo Vieiro International Airport(BXO)',
  'Blackpool(BLK)',
  'Blackwater(BLT)',
  'Blantyre (Mandala) - Chileka International Airport(BLZ)',
  'Blenheim(BHE)',
  'Bloemfontein - Bloemfontein Airport(BFN)',
  'Bloomington (IL)(BMI)',
  'Bloomington (IN)(BMG)',
  'Bluefield (WV)(BLF)',
  'Boa Vista(BVB)',
  'Bobo/Dioulasso(BOY)',
  'Bodo(BOO)',
  'Bodrum - Milas Airport(BJV)',
  'Bogota - El Nuevo Dorado International Airport(BOG)',
  'Boise (ID) - Boise Air Terminal(BLI)',
  'Bologna(BLQ)',
  'Bombay (Mumbai) - Chhatrapati Shivaji International(BOM)',
  'Bonaire(BON)',
  'Bonaventure, PQ(YVB)',
  'Bora Bora(BOB)',
  'Bordeaux - Bordeaux Airport(BOD)',
  'Borrego Springs (CA)(BXS)',
  'Boston (MA) - General Edward Lawrence Logan(BOS)',
  'Bouake(BYK)',
  'Bourgas/Burgas(BOJ)',
  'Bournemouth(BOH)',
  'Bowen(ZBO)',
  'Bozeman (MT)(BZN)',
  'Bradford/Warren (PA) /Olean (NY)(BFD)',
  'Brainerd (MN)(BRD)',
  'Brampton Island(BMP)',
  'Brasilia - President Juscelino Kubitschek International(BSB)',
  'Bratislava - M. R. Štefánik Airport(BTS)',
  'Brazzaville - Maya-Maya Airport(BZV)',
  'Bremen - Bremen Airport(BRE)',
  'Brescia, Montichiari(VBS)',
  'Brest(BES)',
  'Bria(BIV)',
  'Bridgeport (CT)(BDR)',
  'Bridgetown - Grantley Adams International(BGI)',
  'Brindisi(BDS)',
  'Brisbane(BNE)',
  'Bristol(BRS)',
  'Broennoeysund(BNN)',
  'Broken Hill(BHQ)',
  'Brookings (SD)(BKX)',
  'Broome(BME)',
  'Brunswick (GA)(BQK)',
  'Brussels - Brussels Airport(BRU)',
  'Bucaramanga(BGA)',
  'Bucharest(BUH)',
  'Bucharest - Henri Coandă International Airport(OTP)',
  'Budapest - Budapest Ferihegy International Airport(BUD)',
  'Buenos Aires(BUE)',
  'Buenos Aires, Ezeiza International Airport(EZE)',
  'Buenos Aires, Jorge Newbery(AEP)',
  'Buffalo Range(BFO)',
  'Buffalo/Niagara Falls (NY)(BUF)',
  'Bujumbura - Bujumbura International Airport(BJM)',
  'Bulawayo(BUQ)',
  'Bullhead City (NV)(BHC)',
  'Bundaberg(BDB)',
  'Burbank (CA)(BUR)',
  'Burlington (VT)(BTV)',
  'Burlington IA(BRL)',
  'Burnie (Wynyard)(BWT)',
  'Butte (MT)(BTM)',
  'Cabinda(CAB)',
  'Cagliari(CAG)',
  'Cairns(CNS)',
  'Cairo - Cairo International Airport(CAI)',
  'Calama - El Loa(CJC)',
  'Calcutta (Kolkata) - Netaji Subhas Chandra(CCU)',
  'Calgary - Calgary International Airport(YYC)',
  'Cali(CLO)',
  'Calicut(CCJ)',
  'Calvi(CLY)',
  'Cambridge Bay(YCB)',
  'Cambridge(CBG)',
  'Campbeltown(CAL)',
  'Campo Grande(CGR)',
  'Canberra - Canberra Airport(CBR)',
  'Cancun(CUN)',
  'Cannes - Mandelieu Airport(CEQ)',
  'Canouan (island) - Canouan Airport(CIW)',
  'Cape Town - Cape Town International Airport(CPT)',
  'Caracas - Simón Bolívar International Airport(CCS)',
  'Cardiff - Cardiff Airport(CWL)',
  'Carlsbad (CA)(CLD)',
  'Carnarvon(CVQ)',
  'Carnot(CRF)',
  'Carson City (NV)(CSN)',
  'Cartagena - Rafael Núñez International Airport(CTG)',
  'Casa de Campo - La Romana International Airport(LRM)',
  'Casablanca(CMN)',
  'Casino(CSI)',
  'Casper (WY)(CPR)',
  'Castaway(CST)',
  'Castries - George F. L. Charles Airport(SLU)',
  'Catania(CTA)',
  'Cayenne - Cayenne-Rochambeau Airport(CAY)',
  'Cebu City - Mactan-Cebu International(CEB)',
  'Cedar City (UT)(CDC)',
  'Cedar Rapids IA(CID)',
  'Ceduna(CED)',
  'Cessnock(CES)',
  'Chabarovsk (Khabarovsk)(KHV)',
  'Chambery(CMF)',
  'Champaign (IL)(CMI)',
  'Chandigarh - Chandigarh International Airport(IXC)',
  'Changchun(CGQ)',
  'Chania(CHQ)',
  'Chaoyang, Beijing - Chaoyang Airport(CHG)',
  'Charleston (SC)(CHS)',
  'Charleston (WV) - Yeager Airport(CRW)',
  'Charlotte (NC)(CLT)',
  'Charlottesville (VA)(CHO)',
  'Charters Towers(CXT)',
  'Chattanooga (TN)(CHA)',
  'Chengdu - Shuangliu(CTU)',
  'Chennai (Madras)(MAA)',
  'Cheyenne (WY) - Cheyenne Regional Airport(CYS)',
  'Chiang Mai - Chiang Mai International Airport(CNX)',
  'Chiba City(QCB)',
  'Chicago (IL)(CHI)',
  'Chicago (IL), Midway(MDW)',
  'Chicago (IL), O\'Hare International Airport(ORD)',
  'Chichen Itza(CZA)',
  'Chico (CA)(CIC)',
  'Chihuahua - Gen Fierro Villalobos(CUU)',
  'Chios(JKH)',
  'Chipata(CIP)',
  'Chisinau - Chișinău International Airport(KIV)',
  'Chita (Tschita)(HTA)',
  'Chitral(CJL)',
  'Chittagong(CGP)',
  'Chongqing - Jiangbei International Airport(CKG)',
  'Christchurch(CHC)',
  'Chub Cay(CCZ)',
  'Churchill(YYQ)',
  'Cienfuegos - Jaime González Airport(CFG)',
  'Cincinnati (OH) - Cincinnati/Northern Kentucky Int\'l(CVG)',
  'Ciudad Del Carmen(CME)',
  'Ciudad Guayana(CGU)',
  'Ciudad Juarez(CUS)',
  'Ciudad Obregon(CEN)',
  'Ciudad Victoria(CVM)',
  'Clarksburg (WV)(CKB)',
  'Clermont(CMQ)',
  'Clermont Ferrand(CFE)',
  'Cleveland (OH) - Cleveland Hopkins International(CLE)',
  'Cleveland (OH), Burke Lakefront(BKL)',
  'Cochabamba(CBB)',
  'Cochin(COK)',
  'Cody/Powell/Yellowstone (WY)(COD)',
  'Coffmann Cove (AK)(KCC)',
  'Coffs Harbour(CFS)',
  'Coimbatore(CJB)',
  'Colima(CLQ)',
  'College Station/Bryan (TX)(CLL)',
  'Collinsville(KCE)',
  'Cologne - Cologne Airport (Flughafen Köln/Bonn)(CGN)',
  'Colombo - Bandaranaike International Airport(CMB)',
  'Colorado Springs (CO)(COS)',
  'Columbia (SC) - Columbia Metropolitan Airport(CAE)',
  'Columbus (GA)(CSG)',
  'Columbus (OH) - Port Columbus International(CMH)',
  'Conakry - Conakry International Airport(CKY)',
  'Concord (CA) - Buchanan Field(CCR)',
  'Concord (NH) - Concord Municipal Airport(CON)',
  'Constanța (Constanța) - Constanța Int\'l Airport(CND)',
  'Constantine(CZL)',
  'Coober Pedy(CPD)',
  'Cooktown(CTN)',
  'Cooma(OOM)',
  'Copenhagen - Copenhagen Airport(CPH)',
  'Cordoba(COR)',
  'Cordova (AK)(CDV)',
  'Corfu(CFU)',
  'Cork(ORK)',
  'Corpus Christi (TX)(CRP)',
  'Cotonou - Cotonou Cadjehoun Airport(COO)',
  'Cottbus - Cottbus-Drewitz Airport(CBU)',
  'Coventry - Baginton(CVT)',
  'Cozumel(CZM)',
  'Craig (AK)(CGA)',
  'Crescent City (CA)(CEC)',
  'Cuiabá - Marechal Rondon International Airport(CGB)',
  'Culiacan(CUL)',
  'Curacao - Curaçao International Airport(CUR)',
  'Curitiba - Afonso Pena International Airport(CWB)',
  'Cuyo(CYU)',
  'Dakar - Léopold Sédar Senghor International Airport(DKR)',
  'Dalaman(DLM)',
  'Dalby(DBY)',
  'Dalian - Zhoushuizi International Airport(DLC)',
  'Dallas (TX), Love Field(DAL)',
  'Dallas/Ft. Worth (TX) - Dallas/Fort Worth International(DFW)',
  'Daloa(DJO)'
];

// Seaport Suggestions
export const seaportSuggestions = [
  'Shanghai Port',
  'Singapore Port',
  'Colombo Port',
  'Chennai Port',
  'Mumbai (JNPT) Port',
  'Hambantota Port',
  'Port Klang',
  'Dubai (Jebel Ali)',
  'Hong Kong Port',
  'Chittagong Port',
  'Karachi Port',
  'Bangkok (Laem Chabang)',
  'Jakarta (Tanjung Priok)',
  'Ho Chi Minh (Cat Lai)'
];

// Carrier Suggestions
export const carrierSuggestions = {
  sea: [
    'Maersk Line',
    'MSC (Mediterranean Shipping Company)',
    'CMA CGM',
    'COSCO Shipping',
    'Hapag-Lloyd',
    'ONE (Ocean Network Express)',
    'Evergreen Line',
    'Yang Ming Line',
    'HMM (Hyundai Merchant Marine)',
    'PIL (Pacific International Lines)',
    'OOCL',
    'ZIM',
    'Wan Hai Lines'
  ],
  air: [
    'Emirates SkyCargo',
    'Qatar Airways Cargo',
    'Singapore Airlines Cargo',
    'Cathay Pacific Cargo',
    'Lufthansa Cargo',
    'Korean Air Cargo',
    'ANA Cargo',
    'Turkish Cargo',
    'Etihad Cargo',
    'Air France-KLM Cargo',
    'China Airlines Cargo',
    'FedEx',
    'DHL Aviation',
    'UPS Airlines'
  ],
  all: [
    'Maersk Line',
    'MSC',
    'CMA CGM',
    'Emirates SkyCargo',
    'Qatar Airways Cargo',
    'Singapore Airlines Cargo'
  ]
};

// Incoterms
export const incotermSuggestions = [
  'EXW (Ex Works)',
  'FCA (Free Carrier)',
  'CPT (Carriage Paid To)',
  'CIP (Carriage and Insurance Paid To)',
  'DAP (Delivered at Place)',
  'DPU (Delivered at Place Unloaded)',
  'DDP (Delivered Duty Paid)',
  'FAS (Free Alongside Ship)',
  'FOB (Free on Board)',
  'CFR (Cost and Freight)',
  'CIF (Cost, Insurance and Freight)'
];

// Currency Suggestions
export const currencySuggestions = [
  'USD',
  'EUR',
  'LKR',
  'GBP',
  'AED',
  'SGD',
  'CNY',
  'JPY',
  'INR',
  'AUD',
  'CAD',
  'HKD',
  'MYR',
  'THB'
];

// Cargo Type Suggestions
export const cargoTypeSuggestions = [
  'General Cargo',
  'Dangerous Goods (DG)',
  'Perishable Goods',
  'Fragile Items',
  'Hazardous Materials',
  'Temperature Controlled',
  'Live Animals',
  'Oversized Cargo',
  'Valuable Cargo',
  'Pharmaceutical Products',
  'Electronics',
  'Garments & Textiles',
  'Machinery & Equipment',
  'Food & Beverages'
];

// Trucking Equipment
export const truckingEquipment = [
  'Dry Van',
  'Flatbed',
  'Refrigerated (Reefer)',
  'Step Deck',
  'Lowboy',
  'Conestoga',
  'Box Truck',
  'Straight Truck',
  'Dump Truck',
  'Tanker',
  'Container Chassis',
  'Double Drop',
  'Extendable Trailer'
];

// Equipment Suggestions
export const equipmentSuggestions = {
  air: [
    'Pallet (96" x 125")',
    'ULD Container - LD3',
    'ULD Container - LD7',
    'ULD Container - LD9',
    'Wooden Crate',
    'Cardboard Box',
    'Skid',
    'Bulk Cargo'
  ],
  sea: [
    '20 FT Standard Container',
    '40 FT Standard Container',
    '40 FT High Cube Container',
    '45 FT High Cube Container',
    '20 FT Refrigerated Container',
    '40 FT Refrigerated Container',
    '20 FT Open Top Container',
    '40 FT Open Top Container',
    '20 FT Flat Rack',
    '40 FT Flat Rack',
    'Bulk Cargo',
    'Break Bulk'
  ],
  trucking: truckingEquipment
};

// Unit Type Suggestions
export const unitTypeSuggestions = [
  'WM',
  'CBM',
  'CONTAINER',
  'KGS',
  'SHIPMENT',
  'TUE',
  'PALLET',
  'CASE',
  'CTN',
  'PKGS',
  'SET',
  'TON',
  'ROLL',
  'BL',
  'DOC',
  'TRUCK',
  '20GP',
  '40HC',
  '20RF',
  '40RF'
];

export const unitTypeSuggestionsAir = [
  "-45 Kg",
  "+45 Kg",
  "+100 kg",
  "+300 kg",
  "+500 kg",
  "+1000 kg",
  "+1500 kg",
  "+2000 kg",
  "+3000 kg",
  "+5000 kg"
];

export const unitTypeSuggestionsSea = [
  "20 GP",
  "40 GP",
  "40 HC",
  "20 RF",
  "40 RF",
  "20 FR",
  "40 FR",
  "20 OT",
  "40 OT",
  "40OTHC",
  "20 ISO",
  "Per/CBM"
];

// Mode-specific Weight Breakers
export const weightBreakerSuggestions = {
  air: [
    '-45 Kg',
    '+45 Kg',
    '+100 Kg',
    '+300 Kg',
    '+500 Kg',
    '+1000 Kg',
    '+1500 Kg',
    '+2000 Kg',
    '+3000 Kg',
    '+5000 Kg'
  ],
  sea: [
    '20 GP',
    '40 GP',
    '40 HC',
    '20 RF',
    '40 RF',
    '20 FR',
    '40 FR',
    '20 OT',
    '40 OT',
    '40OTHC',
    '20 ISO',
    'Per/CBM'
  ],
  trucking: [
    'Per Truck',
    'Per Kg',
    'Per Ton',
    'Per Mile',
    'Per Km',
    'Flat Rate',
    'Per Pallet',
    'Per CBM'
  ]
};

// Pricing Unit Suggestions
export const pricingUnitSuggestions = [
  'Per Kg',
  'Per Lb',
  'Per Container',
  'Per CBM (Cubic Meter)',
  'Per Shipment',
  'Flat Rate',
  'Per Unit',
  'Per Pallet',
  'Per Ton',
  'Per Day'
];




// Charge Name Suggestions
export const chargeNameSuggestions = {
  freight: [
    'Ocean Freight',
    'Air Freight',
    'Fuel Surcharge (BAF)',
    'Currency Adjustment Factor (CAF)',
    'Peak Season Surcharge',
    'War Risk Surcharge',
    'Emergency Surcharge'
  ],
  destination: [
    'Terminal Handling Charge (THC)',
    'Documentation Fee',
    'Customs Clearance',
    'Port Charges',
    'Delivery Order (DO) Fee',
    'Container Detention',
    'Demurrage',
    'Inspection Fee',
    'Fumigation',
    'Storage Charges'
  ],
  origin: [
    'Warehouse Handling',
    'Loading Charges',
    'Stuffing Charges',
    'VGM (Verified Gross Mass)',
    'Seal Charges',
    'Lashing & Securing',
    'Export Customs',
    'Bill of Lading Fee'
  ],
  handling: [
    'EXW Charges',
    'BL Fee',
    'CFS charges',
    'Loading/ Unloading',
    'Custom clearance charges',
    'Handling Charges',
    'PSS charges',
    'ACI Fee',
    'AMS Fee',
    'ECI fee',
    'Pickup Charges',
    'CMB/KWI/CAI',
    'NB FROM KWI/CAI',
    'Local Forwarding charges',
    'SLPA charges',
    'Doc Fee',
    'Export license fee',
    'Trico Gatepass',
    'VGM fee',
    'Manifest amendment fee',
    'EDI charges',
    'Peek charges',
    'Origin Charges',
    'Others',
    'Waiting Charges',
    'Palletizing Charges',
    'Labour Charges',
    'Equipment charges'
]

};

// Terms & Conditions Templates
export const termsConditionsSuggestions = [
  'Payment terms: 30 days from invoice date',
  'Payment terms: 15 days from invoice date',
  'Payment terms: Cash on delivery (COD)',
  'Payment terms: 50% advance, 50% on delivery',
  'Prices are subject to change without prior notice',
  'All rates are valid for 30 days from quote date',
  'All rates are valid for 15 days from quote date',
  'All customs duties and taxes are excluded',
  'All customs duties and taxes are included',
  'Insurance is not included unless specified',
  'Insurance coverage available at 0.5% of cargo value',
  'Free storage for first 3 days, charges apply thereafter',
  'Free demurrage for 5 days at destination',
  'Cargo must be ready for pickup within 24 hours of booking',
  'Subject to space and equipment availability',
  'Rates based on commodity declaration provided',
  'Additional charges may apply for oversized/overweight cargo',
  'Customer responsible for proper packaging and marking',
  'Delivery time estimates are approximate and not guaranteed',
  'Claims must be reported within 24 hours of delivery',
  'Force majeure clause applicable',
  'Rates exclude weekend/holiday delivery charges'
];

// Origin/Destination for MultiModal
export const multiModalOrigins = [
  'Beijing',
  'Shanghai',
  'Guangzhou',
  'Shenzhen',
  'Hong Kong',
  'Singapore',
  'Dubai',
  'Mumbai',
  'Chennai',
  'Bangkok',
  'Kuala Lumpur',
  'Jakarta',
  'Tokyo',
  'Seoul',
  'Taipei'
];

export const multiModalDestinations = [
  'Colombo',
  'Chennai',
  'Mumbai',
  'Delhi',
  'Bangalore',
  'Karachi',
  'Dhaka',
  'Bangkok',
  'Singapore',
  'Kuala Lumpur',
  'Jakarta',
  'Manila',
  'Male',
  'Port Louis'
];

// Trucking Carriers
export const truckingCarriers = [
  'DHL Freight',
  'DB Schenker',
  'Kuehne + Nagel',
  'XPO Logistics',
  'FedEx Freight',
  'UPS Freight',
  'YRC Freight',
  'Estes Express',
  'Old Dominion',
  'Saia Motor Freight',
  'ABF Freight',
  'TForce Freight',
  'Ryder',
  'J.B. Hunt',
  'Schneider National'
];



// Helper function to get carriers based on category
export const getCarriersByCategory = (category) => {
  if (category === 'air') return carrierSuggestions.air || [];
 if (category === 'sea') return carrierSuggestions.sea || [];
 if (category === 'trucking') return truckingCarriers || [];

 // Default / fallback: combine sea + air + all + trucking
 return [
   ...(carrierSuggestions.sea || []),
   ...(carrierSuggestions.air || []),
   ...(carrierSuggestions.all || []),
   ...truckingCarriers
 ];
};

// Helper function to get equipment based on category
export const getEquipmentByCategory = (category) => {
  if (category === 'air') return equipmentSuggestions.air;
  if (category === 'sea') return equipmentSuggestions.sea;
  if (category === 'trucking') return equipmentSuggestions.trucking;
  return [...equipmentSuggestions.air, ...equipmentSuggestions.sea, ...equipmentSuggestions.trucking];
};

// Helper function to get port suggestions based on category
export const getPortSuggestions = (category) => {
  if (category === 'air') return airportSuggestions;
  if (category === 'sea') return seaportSuggestions;
  return [...airportSuggestions, ...seaportSuggestions];
};

// Helper function to get port suggestions based on category
export const getUOMSuggestions = (category) => {
  if (category === 'air') return unitTypeSuggestionsAir;
  if (category === 'sea') return unitTypeSuggestionsSea;
  return [...unitTypeSuggestionsAir, ...unitTypeSuggestionsSea];
};

export const getWeightBreakersByMode = (mode) => {
  if (mode === 'air') return weightBreakerSuggestions.air;
  if (mode === 'sea') return weightBreakerSuggestions.sea;
  if (mode === 'trucking') return weightBreakerSuggestions.trucking;
  return [...weightBreakerSuggestions.air, ...weightBreakerSuggestions.sea, ...weightBreakerSuggestions.trucking];
};